<template>
   <v-container
  class="overflow-y-auto"
  >
    <v-divider class="mt-12"></v-divider>
    <h3 style=" font-family: Times New Roman, Georgia, Serif;font-weight: bold"
     class="text-center black--text">{{$store.state.hijo.nombre}}</h3>
    <v-divider></v-divider>


<v-layout row wrap pa-2>
        <v-flex md6 sm12 xs12>
                  <v-img
                  :src="$store.state.hijo.foto"
                  max-height="550"
                  max-width="550"
                  aspect-ratio="1"
                ></v-img>
        </v-flex>

        <v-flex md6 sm12 xs12 class="mt-2">
          <v-divider></v-divider>
             <h2 
             style=" font-family: Times New Roman, Georgia, Serif;font-weight: bold"
             class="text-center headline red--text">Selecciona tu Color/Talla</h2>
              <v-row  no-gutters>
      <v-col class="mt-n1 mx-auto"
        v-for="cate in $store.state.hijo.fotos"  v-bind:key="cate"
        cols="4"
        xs="2"
        sm="4"
        md="4">
       
        <v-flex class="pa-1">  
          
                <v-img
                  :src="cate.foto"
                  aspect-ratio="1"
                  @click="confirma=true,tallaselecta=cate.tallaunica,
                  $vuetify.goTo('#about'),
                  codigounico=cate.codigounico,
                  colorselecto=cate.foto"
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
                <v-card class="text-center">
                  <span class="black--text text-center subtitle-1">{{cate.tallaunica}}</span>
                </v-card>
                  
        </v-flex>
        
      </v-col>
      
          </v-row>

  

                <v-divider id='about'></v-divider>
               <p  v-if="confirma" 
               class="mt-5 mx-auto text-center title font-weight-black red--text">VERIFICA</p>
                <v-layout row wrap pa-1 mt-n3  v-if="confirma">
        <v-row  class="mt-n5 text-center">
               <v-col cols="12" xs="12">
              <v-avatar  size="200">
                      <img
                        :src="colorselecto"
                      >
                    </v-avatar>
              </v-col>
              <p class="text-center mx-auto title">Talla {{tallaselecta}}</p>
              
        </v-row>
     
       
                   
                </v-layout>

                <v-layout row wrap pa-n2 mt-n2  v-if="confirma">
                    <v-row>
            <v-col cols="4" xs="1">
            <v-btn class="mx-auto text-center" 
            small 
            block
            @click="agregaalCarrito($store.state.hijo),confirma=false,seleccionColor=false"
            color="primary"
            >OTRA TALLA
            </v-btn>
                </v-col>

                <v-col cols="4" xs="1">
            <v-btn class="mx-auto text-center" 
            small 
            block
            @click="agregaalCarrito($store.state.hijo), seguircomprando()"
            color="primary"
            >IR A TIENDA
            </v-btn>
                </v-col>
            <v-col cols="4" xs="1">
                <router-link to="/carrito" > 
            <v-btn class="mx-auto text-center" 
            small
            @click="agregaalCarrito($store.state.hijo)"
            block
            color="error"
            >IR A Carrito
            </v-btn>
                </router-link>
                </v-col>
                    </v-row>

                </v-layout>
        </v-flex>

</v-layout>

       <cuerpoprincipal />

  </v-container>
</template>

<script>
import cuerpoprincipal from '@/components/cuerpoprincipal'
import mensajeCard from '@/components/mensajeCard'
import store from '@/store/index'

  export default {
    name: 'pagProductos',
      components: {
        cuerpoprincipal,
        mensajeCard,
  },

    data() {
        return {
          seleccionColor: false,
          confirma:false,
          tallaselecta:'',
          colorselecto:'',
          codigounico:''
        }
      },
     mounted() {
        if(!store.state.hijo.foto){
           window.history.back();
        }
     },
       methods: {
         seguircomprando(){
            window.history.back();
         },
        agregaalCarrito(producto){
            var carrito
            var precioacobrar
            var codigos = this.create_UUID()
            if(producto.pdescuento==0){
              precioacobrar = producto.pnormal
            }else{
              precioacobrar = producto.pdescuento
            }
            carrito = {
              codigo:codigos,
              nombre:producto.nombre,
              categoria:producto.categoria,
              linea:producto.linea,
              marca:producto.marca,
              precio:precioacobrar,
              foto:producto.foto,
              talla:this.tallaselecta,
              color:this.colorselecto,
              codigounico:this.codigounico,
            }
            store.commit('increment',1)
            store.commit('ingresacarrito',carrito)
            store.commit('sumacarrito', parseFloat(precioacobrar))
            store.commit('sumatotalproductos',1)

        },
            create_UUID(){
              var dt = new Date().getTime();
              var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                  var r = (dt + Math.random()*16)%16 | 0;
                  dt = Math.floor(dt/16);
                  return (c=='x' ? r :(r&0x3|0x8)).toString(16);
              });
              return uuid;
          },
       }
     

  }
</script>